module.exports = __webpack_public_path__ + "static/family-mobile-3d61900c3c0e75b5bd65dd237e47a16e.png";